// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "./App.css";

import Login from "./components/login";
import CustomerPage from "./components/customer";
import OriginPage from "./components/origin";
import UserPage from "./components/user";
import Home from "./components/Home";
import Layout from "./components/general/Layout";
import Scheduling from "./components/processing/Scheduling";
import ProcessMonitor from "./components/processing/ProcessMonitor";
import ReportingPage from "./components/reporting";
import ERPEnquiryPage from "./components/nlis/erpEnquiry";
import DeviceStatusPage from "./components/nlis/deviceStatus";
import KillRegisterPage from "./components/nlis/killRegister";
import HoldingsPage from "./components/nlis/holdings";
import ERPExceptionsPage from "./components/nlis/erpExceptions";
import NlisSettings from "./components/admin/NlisSettings";

import { AuthProvider } from "./helpers/AuthContext";
import { CompanyProvider } from "./helpers/CompanyContext";
import PrivateRoute from "./helpers/PrivateRoute";
import PublicRoute from "./helpers/PublicRoute";
import { FeatureProvider } from "./helpers/FeatureContext";

function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
        <FeatureProvider>
        <Router>
          <Routes>
            {/* Public (no Layout wrapper) */}
            <Route path="/login" element={<PublicRoute element={<Login />} />} />

            {/* Private (Layout wrapper) */}
            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<PrivateRoute element={Home} />} />


                    {/* Scheduling: route kept but hidden from menu */}
                    <Route
                      path="/processing/scheduling"
                      element={<PrivateRoute element={Scheduling} />}
                    />
                    <Route
                      path="/processing/process_monitor"
                      element={<PrivateRoute element={ProcessMonitor} />}
                    />

                    <Route
                      path="/customers"
                      element={<PrivateRoute element={CustomerPage} />}
                    />
                    <Route
                      path="/origins"
                      element={<PrivateRoute element={OriginPage} />}
                    />
                    <Route
                      path="/users"
                      element={<PrivateRoute element={UserPage} />}
                    />

                    <Route
                      path="/reporting"
                      element={<PrivateRoute element={ReportingPage} />}
                    />

                    <Route
                      path="/settings/nlis"
                      element={<PrivateRoute element={NlisSettings} />}
                    />

                    <Route
                      path="/nlis/erp-enquiry"
                      element={<PrivateRoute element={ERPEnquiryPage} />}
                    />
                    <Route
                      path="/nlis/device-status"
                      element={<PrivateRoute element={DeviceStatusPage} />}
                    />
                    {/* Kill Upload: route kept but hidden from menu */}
                    <Route
                      path="/nlis/kill-register"
                      element={<PrivateRoute element={KillRegisterPage} />}
                    />
                    <Route
                      path="/nlis/holdings"
                      element={<PrivateRoute element={HoldingsPage} />}
                    />
                    <Route
                      path="/nlis/erp-exceptions"
                      element={<PrivateRoute element={ERPExceptionsPage} />}
                    />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </Router>
        </FeatureProvider>
      </CompanyProvider>
    </AuthProvider>
  );
}

export default App;